.loading {
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: loader;
  animation-timing-function: linear;
  background-size: 1000px 640px;
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 6px;
  @include themify($themes) {
    background-image: linear-gradient(
      to right,
      rgba(themed("neutral-secondary"), 0.5) 8%,
      rgba(themed("neutral-primary"), 0.5) 38%,
      rgba(themed("neutral-secondary"), 0.5) 54%
    );
  }
  @include dark-mode() {
    @include themify($themes) {
      background-image: linear-gradient(
        to right,
        rgba(themed("neutral-tertiary"), 0.5) 8%,
        rgba(themed("neutral-primary"), 0.5) 38%,
        rgba(themed("neutral-tertiary"), 0.5) 54%
      );
    }
  }
  @keyframes loader {
    0% {
      background-position: -480px 0;
    }
    100% {
      background-position: 480px 0;
    }
  }

  &.textLoader {
    height: 23px;
    margin-top: 5px;
    width: 60px;
    border-radius: 6px;
  }
}
